import {
  Box, Button, Flex, Icon, Tab, TabIndicator, TabList, useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import { BsFillFloppyFill, BsArrowLeft } from 'react-icons/bs';
import {
  Link, useLocation, useParams,
} from 'react-router-dom';
import { useUpdateFormMutation } from '../../Services/apiSlice';
import useFormDraft from '../../helpers/useFormDraft';
import { useGetTemplateDraftQuery, useUpdateTemplateMutation } from '../../Services/templates';

const tabProps = {
  variant: 'outline',
  size: 'sm',
  px: '1',
  mx: '1',
  fontSize: 'sm',
  w: '160px',
  _selected: { color: 'blue.700', fontWeight: 'bold' },
};

const PreviewMenu = () => {
  const variantChange = '0.2s linear';
  const sidebarMargins = '0px';
  const sidebarRadius = '10px';
  const { templateId } = useParams();
  const { pathname } = useLocation();

  const sidebarBg = useColorModeValue('white', 'navy.800');
  const { isFetching, data: form } = pathname.startsWith('/form') ? useFormDraft() : useGetTemplateDraftQuery(templateId);
  const [updateForm, { isLoading }] = pathname.startsWith('/form') ? useUpdateFormMutation() : useUpdateTemplateMutation();
  const toast = useToast();

  const handleSave = async () => {
    const rta = updateForm(form).then(({ error }) => { if (error) { console.log(error); throw new Error(error.data?.error); } });

    toast.promise(rta, {
      success: {
        title: 'Changes saved successfully', isClosable: true, variant: 'left-accent', duration: 2000,
      },
      error: {
        title: 'Ocurrió un error al guardar los cambios',
        variant: 'left-accent',
        position: 'top',
        isClosable: true,
      },
      loading: { title: 'Please wait...', position: 'top' },
    });
  };

  return (
    <Box display="block" position="relative" w="100%">
      <Flex
        bg={sidebarBg}
        transition={variantChange}
        mb={{
          sm: '16px',
        }}
        h="40px"
        py="4px"
        px="8px"
        m={sidebarMargins}
        filter="drop-shadow(0px 5px 14px rgba(0, 0, 0, 0.05))"
        borderRadius={sidebarRadius}
        justify="center"
      >
        <TabList my="2px" color="gray.700">
          <Tab {...tabProps}>
            Desktop
          </Tab>
          <Tab {...tabProps}>
            Tablet
          </Tab>
          <Tab {...tabProps}>
            Mobile
          </Tab>
        </TabList>
        <TabIndicator height="2px" bg="blue.500" borderRadius="1px" bottom="6px" />
      </Flex>
      <Box position="absolute" top="4px" right="8px">
        <Button as={Link} to="../edit" leftIcon={<Icon as={BsArrowLeft} />} colorScheme="blue" variant="outline" size="sm" mx="2">
          Back
        </Button>
        <Button
          leftIcon={<Icon as={BsFillFloppyFill} />}
          colorScheme="blue"
          variant="solid"
          size="sm"
          onClick={handleSave}
          isDisabled={isFetching || isLoading}
        >
          Save
        </Button>
      </Box>
    </Box>

  );
};

export default PreviewMenu;
